import { useEffect, useState } from "react";
import { LoaderCircle, X } from "lucide-react";
import { camp } from "@/data/camp";

const skillLevels = ["Beginner", "Intermediate", "Advanced", "Elite"];
const initialForm = { parentName: "", parentEmail: "", camperName: "", skillLevel: "Beginner" };

function RegistrationModal() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const handleOpen = () => { if (!camp.registrationEnabled) return; setError(""); setOpen(true); };
    const handleKeyDown = (event) => { if (event.key === "Escape") setOpen(false); };
    window.addEventListener("open-registration", handleOpen);
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("open-registration", handleOpen);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const updateField = (event) => setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  const close = () => { if (!submitting) setOpen(false); };

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payments/checkout`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          lookup_key: camp.stripeLookupKey,
          origin_url: window.location.origin,
          parent_name: form.parentName,
          parent_email: form.parentEmail,
          camper_name: form.camperName,
          skill_level: form.skillLevel,
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.detail || "We could not start checkout. Please try again.");
      if (!payload.checkout_url) throw new Error("Stripe did not return a checkout link.");
      window.location.assign(payload.checkout_url);
    } catch (submissionError) {
      setError(submissionError.message);
      setSubmitting(false);
    }
  };

  if (!open) return null;
  return <div className="registration-overlay" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) close(); }} data-testid="registration-modal"><div className="registration-dialog" role="dialog" aria-modal="true" aria-labelledby="registration-title"><div className="registration-dialog-top"><div><p className="section-kicker">Secure registration</p><h2 id="registration-title">Reserve your<br /><span>place at camp</span></h2></div><button className="modal-close" type="button" onClick={close} aria-label="Close registration form" data-testid="registration-close-btn"><X size={21} /></button></div><p className="registration-copy">Enter the details below, then continue to secure Stripe Checkout for the {camp.price} camp registration.</p><form onSubmit={submit} data-testid="registration-form"><label htmlFor="parent-name">Parent / guardian name<input id="parent-name" name="parentName" value={form.parentName} onChange={updateField} autoComplete="name" required minLength={2} maxLength={120} data-testid="parent-name-input" /></label><label htmlFor="parent-email">Parent / guardian email<input id="parent-email" name="parentEmail" type="email" value={form.parentEmail} onChange={updateField} autoComplete="email" required data-testid="parent-email-input" /></label><label htmlFor="camper-name">Camper name<input id="camper-name" name="camperName" value={form.camperName} onChange={updateField} required minLength={2} maxLength={120} data-testid="camper-name-input" /></label><label htmlFor="skill-level">Golf skill level<select id="skill-level" name="skillLevel" value={form.skillLevel} onChange={updateField} data-testid="skill-level-select">{skillLevels.map((level) => <option key={level} value={level}>{level}</option>)}</select></label>{error && <p className="registration-error" role="alert" data-testid="registration-error">{error}</p>}<button className="register-link registration-submit" type="submit" disabled={submitting} data-testid="registration-submit-btn">{submitting ? <><LoaderCircle className="spin" size={17} /> Opening secure checkout</> : <>Continue to Stripe Checkout <span aria-hidden="true">↗</span></>}</button></form><p className="registration-footnote">Payments are processed securely by Stripe. Check-in begins at 9:00 AM on November 15, 2026.</p></div></div>;
}

export default RegistrationModal;
